<template>
  <div class="monitor_wrap">
    <div class="shadow"></div>
    <div class="mainHead">
      <div class="route">
        <span class="crumbs"></span><span class="router_link" @click="linkIndex">报警处理</span><span class="arrow">></span><span class="router_link" @click="linkDetail">报警详情</span><span class="arrow">></span><span>{{formTitle}}</span>
      </div>
      <div>
        <el-button type="primary" @click="isRequestFill" v-if="isAddForm&&isAuth('alarmManager:creatAlarmSheet')||!isAddForm&&isAuth('alarmManager:changeDealMonitorRecord')">提交审核</el-button>
        <el-button type="primary" @click="saveFormData" v-if="isAddForm&&isAuth('alarmManager:creatAlarmSheet')||!isAddForm&&isAuth('alarmManager:changeDealMonitorRecord')">保存</el-button>
        <el-button type="primary" @click="returnBtn">返回</el-button>
      </div>
    </div>
    <div class="main clearfix" :style="{height:basicHeight+'px'}">
      <el-row>
        <el-col :span="24">
          <div class="maindetails">
            <div class="item_info">
              <p v-if="isAddForm"><span>处理单编号:</span>--</p>
              <p v-else><span>处理单编号:</span>{{alarmDealCode}}</p>
              <p><span>当前状态:</span>{{runStatus}}</p>
            </div>
            <div class="item_info">
              <p><span>监测点名称:</span>{{monitoringName}}</p>
              <p><span>监测点编号:</span>{{monitoringCode}}</p>
            </div>
            <div class="item_info">
              <p v-if="isAddForm"><span>创建时间:</span>--</p>
              <p v-else><span>创建时间:</span>{{createTime}}</p>
              <p><span>排故时间:</span> <span class="date_picker"><el-date-picker
                v-model="formParams.solveTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="pickerOptions"
                placeholder="选择日期时间">
              </el-date-picker></span></p>
            </div>
            <div class="item_info">
              <p v-if="isAddForm"><span>提交时间:</span>--</p>
              <p v-else><span>提交时间:</span>{{submitTime}}</p>
              <p v-if="isAddForm"><span>审核时间:</span>--</p>
              <p v-else><span>审核时间:</span>{{verifyTime}}</p>
            </div>
            <div class="item_info">
              <p><span style="width: 93px">处理人员:</span> <el-select v-model="formParams.handleId" placeholder="请选择" :disabled="disabled" multiple>
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.userName"
                  :disabled="item.disabled"
                  :value="item.id">
                </el-option>
              </el-select></p>
              <p v-if="isAddForm"><span>填写人员:</span>--</p>
              <p v-else><span>填写人员:</span>{{writeName}}</p>
            </div>
            <div class="item_info" style="margin-bottom: 27px">
              <p style="position: relative">
                <span style="position: absolute;top: 0">照片附件:</span>
                <span class="all_img_container">
                  <el-upload
                    :action="upLoadAjaxUrl"
                    accept="image/jpg,image/jpeg,image/png,image/JPG,image/JPEG,image/PNG"
                    list-type="picture-card"
                    :limit="maxNumber"
                    :file-list="fileList"
                    class="upload_img"
                    :on-progress="handleProgress"
                    :beforeUpload="beforeAvatarUpload"
                    :on-success="upLoadImg"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove">
                   <i class="el-icon-plus"></i>
                    <!--<el-progress type="circle" :percentage="progressNum" class="upload_process" :width="54" :stroke-width="4"></el-progress>-->
</el-upload>

<!--<el-dialog :visible.sync="dialogVisible">-->
  <!--&lt;!&ndash;<img width="100%" :src="dialogImageUrl" alt="">&ndash;&gt;-->
<!--</el-dialog>-->
                </span>
              </p>
            </div>
          </div>
          <!--<div class="img_preview">-->
              <!--<div>-->
                <!---->
              <!--</div>-->
          <!--</div>-->
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="warning_desi">
            <span class="crumbs"></span><span>报警故障描述</span>
            <span class="convenientBtn" @click="convenientBtn(1)"><img src="../../../static/img/convenient.png" alt=""></span>
          </div>
          <div>
            <div class="warning_desi_data">
              <el-input
                type="textarea"
                :rows="2"
                maxlength="500"
                :disabled="disabled"
                @input="getSizeNum1"
                placeholder="请输入内容"
                v-model="formParams.alarmRemark">
              </el-input>
              <span class="textarea_tip">{{currentNum1}}/500</span>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="warning_desi">
            <span class="crumbs"></span><span>报警原因分析</span>
            <span class="convenientBtn" @click="convenientBtn(2)"><img src="../../../static/img/convenient.png" alt=""></span>
          </div>
          <div>
            <div class="warning_desi_data">
              <el-input
                type="textarea"
                :rows="2"
                maxlength="500"
                :disabled="disabled"
                @input="getSizeNum2"
                placeholder="请输入内容"
                v-model="formParams.alarmReason">
              </el-input>
              <span class="textarea_tip">{{currentNum2}}/500</span>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="warning_desi">
            <span class="crumbs"></span><span>处理结果/对策</span>
            <span class="convenientBtn" @click="convenientBtn(3)"><img src="../../../static/img/convenient.png" alt=""></span>
          </div>
          <div>
            <div class="warning_desi_data">
              <el-input
                type="textarea"
                :disabled="disabled"
                :rows="2"
                maxlength="500"
                placeholder="请输入内容"
                @input="getSizeNum3"
                v-model="formParams.result">
              </el-input>
              <span class="textarea_tip">{{currentNum3}}/500</span>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" v-if="(isAuth('common:interface')&&!isAddForm)||(isAddForm&&isAuth('common:interface'))">
          <!--灭火瓶-->
          <div class="look_table_data table_data" v-if="deviceType==6">
            <el-table
              :data="tableData"
              stripe
              @selection-change="handleSelectionChange"
              ref="multipleTable"
              border
              style="width: 884px">
              <el-table-column
                type="selection"
                width="54">
              </el-table-column>
              <el-table-column
                label="序号"
                width="79">
                <template slot-scope="scope">
                  <div>{{tableParams.pageSize*(tableParams.currentPage-1)+(scope.$index+1)}}</div>
                </template>
              </el-table-column>
              <el-table-column
                label="设备状态"
                width="140">
                <template slot-scope="scope">
                  <div v-if="scope.row.deviceStatus" style="color: #f55353">故障</div>
                  <div v-else>启用</div>
                </template>
              </el-table-column>
              <el-table-column
                label="监测状态"
                width="140">
                <template slot-scope="scope">
                  <div v-if="scope.row.runStatus==1" style="color: #f55353">告警</div>
                  <div v-else-if="scope.row.runStatus==2" style="color: #f55353">预警</div>
                  <div v-else>正常</div>
                </template>
              </el-table-column>
              <el-table-column
                width="140"
                show-overflow-tooltip
                label="气压值(MPa)">
                <template slot-scope="scope">
                  <div v-if="scope.row.runStatus==1||scope.row.runStatus==2" style="color: #f55353">{{scope.row.rcv}}</div>
                  <div v-else>{{scope.row.rcv}}</div>
                </template>
              </el-table-column>
              <!-- <el-table-column
                width="140"
                show-overflow-tooltip
                label="电池电量(V)">
                <template slot-scope="scope">
                  <div v-if="scope.row.isAlarmBattery" style="color: #f55353">{{scope.row.battery/100}}</div>
                  <div v-else>{{scope.row.battery/100}}</div>
                </template>
              </el-table-column> -->
                                    <el-table-column label="电池电量"  width="85">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.isAlarmBattery" style="color: #f55353">电量低</div>
                                          <div v-else-if="scope.row.isAlarmBattery==false">正常</div>
                                          <div v-else>--</div>
                                        </template>
                                      </el-table-column>
                                    <el-table-column label="信号强度"  width="85">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.signaler == 0 || scope.row.signaler == 1 || scope.row.signaler == 2">弱</div>
                                          <div v-else-if="scope.row.signaler == 3 || scope.row.signaler == 4 || scope.row.signaler == 5">强</div>
                                          <div v-else>--</div>
                                        </template>
                                      </el-table-column>
              <el-table-column
                prop="recordTime"
                show-overflow-tooltip
                width="160"
                label="记录时间">
              </el-table-column>
            </el-table>
          </div>
          <!--液位-->
          <div class="look_table_data table_data" v-if="deviceType==3">
            <el-table
              :data="tableData"
              stripe
              @selection-change="handleSelectionChange"
              ref="multipleTable"
              border
              style="width: 884px">
              <el-table-column
                type="selection"
                width="54">
              </el-table-column>
              <el-table-column
                label="序号"
                width="79">
                <template slot-scope="scope">
                  <div>{{tableParams.pageSize*(tableParams.currentPage-1)+(scope.$index+1)}}</div>
                </template>
              </el-table-column>
              <el-table-column
                label="设备状态"
                width="140">
                <template slot-scope="scope">
                  <div v-if="scope.row.deviceStatus" style="color: #f55353">故障</div>
                  <div v-else>启用</div>
                </template>
              </el-table-column>
              <el-table-column
                label="监测状态"
                width="140">
                <template slot-scope="scope">
                  <div v-if="scope.row.runStatus==1" style="color: #f55353">告警</div>
                  <div v-else-if="scope.row.runStatus==2" style="color: #f55353">预警</div>
                  <div v-else>正常</div>
                </template>
              </el-table-column>
              <el-table-column
                width="140"
                show-overflow-tooltip
                label="液位值(m)">
                <template slot-scope="scope">
                  <div v-if="scope.row.runStatus==1||scope.row.runStatus==2" style="color: #f55353">{{scope.row.rcv}}</div>
                  <div v-else>{{scope.row.rcv}}</div>
                </template>
              </el-table-column>
              <!-- <el-table-column
                width="140"
                show-overflow-tooltip
                label="电池电量(V)">
                <template slot-scope="scope">
                  <div v-if="scope.row.isAlarmBattery" style="color: #f55353">{{scope.row.battery/100}}</div>
                  <div v-else>{{scope.row.battery/100}}</div>
                </template>
              </el-table-column> -->
                                                  <el-table-column label="电池电量"  width="85">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.isAlarmBattery" style="color: #f55353">电量低</div>
                                          <div v-else-if="scope.row.isAlarmBattery==false">正常</div>
                                          <div v-else>--</div>
                                        </template>
                                      </el-table-column>
                                    <!-- <el-table-column label="信号强度"  width="85">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.signaler == 0 ||scope.row.signaler == 1 || scope.row.signaler == 2">弱</div>
                                          <div v-else-if="scope.row.signaler == 3 || scope.row.signaler == 4 || scope.row.signaler == 5">强</div>
                                          <div v-else>--</div>
                                        </template>
                                      </el-table-column> -->
              <el-table-column
                prop="recordTime"
                show-overflow-tooltip
                width="245"
                label="记录时间">
              </el-table-column>
            </el-table>
          </div>
          <!--烟感-->
          <div class="look_table_data table_data" v-if="deviceType==5">
            <el-table
              :data="tableData"
              stripe
              @selection-change="handleSelectionChange"
              ref="multipleTable"
              border
              style="width: 884px">
              <el-table-column
                type="selection"
                width="54">
              </el-table-column>
              <el-table-column
                label="序号"
                width="79">
                <template slot-scope="scope">
                  <div>{{tableParams.pageSize*(tableParams.currentPage-1)+(scope.$index+1)}}</div>
                </template>
              </el-table-column>
              <el-table-column
                label="设备状态"
                width="105">
                <template slot-scope="scope">
                  <div v-if="scope.row.deviceStatus" style="color: #f55353">故障</div>
                  <div v-else>启用</div>
                </template>
              </el-table-column>
              <el-table-column
                label="监测状态"
                width="145">
                <template slot-scope="scope">
                  <div v-if="scope.row.runStatus==1" style="color: #f55353">
                    <span v-if="scope.row.rcv == 1 || scope.row.rcv == 111">烟雾告警</span>
                    <span v-else-if="scope.row.rcv == 963">防拆告警</span>
                    <span v-else-if="scope.row.rcv == 986">高温告警</span>
                  </div>
                  <div v-else-if="scope.row.runStatus==2" style="color: #f55353">预警</div>
                  <div v-else>正常</div>
                </template>
              </el-table-column>
              <!-- <el-table-column
                width="185"
                show-overflow-tooltip
                label="电池电量(V)">
                <template slot-scope="scope">
                  <div v-if="scope.row.isAlarmBattery" style="color: #f55353">{{scope.row.battery/100}}</div>
                  <div v-else>{{scope.row.battery/100}}</div>
                </template>
              </el-table-column> -->
                                       <el-table-column label="环境温度（℃）" min-width="120">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.exField1">{{scope.row.exField1}}</div>
                                          <div v-else>--</div>
                                        </template>
                                      </el-table-column>
                                       <el-table-column label="电池电量"  width="95">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.isAlarmBattery" style="color: #f55353">电量低</div>
                                          <div v-else-if="scope.row.isAlarmBattery==false">正常</div>
                                          <div v-else>--</div>
                                        </template>
                                      </el-table-column>
                                    <el-table-column label="信号强度"  width="95">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.signaler == 0 ||scope.row.signaler == 1 || scope.row.signaler == 2">弱</div>
                                          <div v-else-if="scope.row.signaler == 3 || scope.row.signaler == 4 || scope.row.signaler == 5">强</div>
                                          <div v-else>--</div>
                                        </template>
                                      </el-table-column>
              <el-table-column
                prop="recordTime"
                show-overflow-tooltip
                width="190"
                label="记录时间">
              </el-table-column>
            </el-table>
          </div>
                    <!--水浸-->
          <div class="look_table_data table_data" v-if="deviceType==7">
            <el-table
              :data="tableData"
              stripe
              @selection-change="handleSelectionChange"
              ref="multipleTable"
              border
              style="width: 884px">
              <el-table-column
                type="selection"
                width="54">
              </el-table-column>
              <el-table-column
                label="序号"
                width="79">
                <template slot-scope="scope">
                  <div>{{tableParams.pageSize*(tableParams.currentPage-1)+(scope.$index+1)}}</div>
                </template>
              </el-table-column>
              <el-table-column
                label="设备状态"
                width="185">
                <template slot-scope="scope">
                  <div v-if="scope.row.deviceStatus" style="color: #f55353">故障</div>
                  <div v-else>启用</div>
                </template>
              </el-table-column>
              <el-table-column
                label="监测状态"
                width="185">
                <template slot-scope="scope">
                  <div v-if="scope.row.runStatus==1" style="color: #f55353">告警</div>
                  <div v-else-if="scope.row.runStatus==2" style="color: #f55353">预警</div>
                  <div v-else>正常</div>
                </template>
              </el-table-column>

              <el-table-column label="电池电量"  width="95">
                <template slot-scope="scope">
                  <div v-if="scope.row.isAlarmBattery" style="color: #f55353">电量低</div>
                  <div v-else-if="scope.row.isAlarmBattery==false">正常</div>
                  <div v-else>--</div>
                </template>
              </el-table-column>
            <el-table-column label="信号强度"  width="95">
                <template slot-scope="scope">
                  <div v-if="scope.row.signaler == 0 ||scope.row.signaler == 1 || scope.row.signaler == 2">弱</div>
                  <div v-else-if="scope.row.signaler == 3 || scope.row.signaler == 4 || scope.row.signaler == 5">强</div>
                  <div v-else>--</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="recordTime"
                show-overflow-tooltip
                width="190"
                label="记录时间">
              </el-table-column>
            </el-table>
          </div>
                              <!--用传-->
          <div class="look_table_data table_data" v-if="deviceType==8">
            <el-table
              :data="tableData"
              stripe
              @selection-change="handleSelectionChange"
              ref="multipleTable"
              border
              style="width: 884px">
              <el-table-column
                type="selection"
                width="54">
              </el-table-column>
              <el-table-column
                label="序号"
                width="70">
                <template slot-scope="scope">
                  <div>{{tableParams.pageSize*(tableParams.currentPage-1)+(scope.$index+1)}}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="channelNo"
                label="设备编号"
                width="103">
              </el-table-column>
              <el-table-column
                label="监测状态"
                width="85">
                <template slot-scope="scope">
                  <div v-if="scope.row.runStatus==1" style="color: #f55353">告警</div>
                  <div v-else-if="scope.row.runStatus==2" style="color: #f55353">预警</div>
                  <div v-else>正常</div>
                </template>
              </el-table-column>
                <el-table-column
                prop="monitoringName"
                show-overflow-tooltip
                width="205"
                label="报警设备">
              </el-table-column>
              <el-table-column
                prop="location"
                show-overflow-tooltip
                width="202"
                label="报警地址">
              </el-table-column>
              <el-table-column
                prop="recordTime"
                show-overflow-tooltip
                width="164"
                label="记录时间">
              </el-table-column>
            </el-table>
          </div>
          <!--水压-->
          <div class="look_table_data table_data" v-if="deviceType==2">
            <el-table
              :data="tableData"
              stripe
              @selection-change="handleSelectionChange"
              ref="multipleTable"
              border
              style="width: 884px">
              <el-table-column
                type="selection"
                width="54">
              </el-table-column>
              <el-table-column
                label="序号"
                width="79">
                <template slot-scope="scope">
                  <div>{{tableParams.pageSize*(tableParams.currentPage-1)+(scope.$index+1)}}</div>
                </template>
              </el-table-column>
              <el-table-column
                label="设备状态"
                width="140">
                <template slot-scope="scope">
                  <div v-if="scope.row.deviceStatus" style="color: #f55353">故障</div>
                  <div v-else>启用</div>
                </template>
              </el-table-column>
              <el-table-column
                label="监测状态"
                width="140">
                <template slot-scope="scope">
                  <div v-if="scope.row.runStatus==1" style="color: #f55353">告警</div>
                  <div v-else-if="scope.row.runStatus==2" style="color: #f55353">预警</div>
                  <div v-else>正常</div>
                </template>
              </el-table-column>
              <el-table-column
                width="140"
                show-overflow-tooltip
                label="水压值(MPa)">
                <template slot-scope="scope">
                                  <div v-if="scope.row.runStatus ==1 ||scope.row.runStatus ==2" style="color: #f55353">{{scope.row.rcv}}</div>
                  <div v-else>{{scope.row.rcv}}</div>
                </template>
              </el-table-column>
              <el-table-column label="电池电量"  width="85">
                  <template slot-scope="scope">
                    <div v-if="scope.row.isAlarmBattery" style="color: #f55353">电量低</div>
                    <div v-else-if="scope.row.isAlarmBattery==false">正常</div>
                    <div v-else>--</div>
                  </template>
                </el-table-column>
              <!-- <el-table-column label="信号强度"  width="85">
                  <template slot-scope="scope">
                    <div v-if="scope.row.signaler == 0 ||scope.row.signaler == 1 || scope.row.signaler == 2">弱</div>
                    <div v-else-if="scope.row.signaler == 3 || scope.row.signaler == 4 || scope.row.signaler == 5">强</div>
                    <div v-else>--</div>
                  </template>
                </el-table-column> -->
              <el-table-column
                prop="recordTime"
                show-overflow-tooltip
                width="245"
                label="记录时间">
              </el-table-column>
            </el-table>
          </div>
          <!--可燃气-->
          <div class="look_table_data table_data" v-if="deviceType==4">
            <el-table
              :data="tableData"
              stripe
              @selection-change="handleSelectionChange"
              ref="multipleTable"
              border
              style="width: 884px">
              <el-table-column
                type="selection"
                width="54">
              </el-table-column>
              <el-table-column
                label="序号"
                width="79">
                <template slot-scope="scope">
                  <div>{{tableParams.pageSize*(tableParams.currentPage-1)+(scope.$index+1)}}</div>
                </template>
              </el-table-column>
              <el-table-column
                label="设备状态"
                width="250">
                <template slot-scope="scope">
                  <div v-if="scope.row.deviceStatus" style="color: #f55353">故障</div>
                  <div v-else>启用</div>
                </template>
              </el-table-column>
              <el-table-column
                label="监测状态"
                width="250">
                <template slot-scope="scope">
                  <div v-if="scope.row.runStatus==1" style="color: #f55353">告警</div>
                  <div v-else-if="scope.row.runStatus==2" style="color: #f55353">预警</div>
                  <div v-else>正常</div>
                </template>
              </el-table-column>
            <el-table-column label="信号强度"  width="90">
                <template slot-scope="scope">
                  <div v-if="scope.row.signaler == 0 || scope.row.signaler == 1 || scope.row.signaler == 2">弱</div>
                  <div v-else-if="scope.row.signaler == 3 || scope.row.signaler == 4 || scope.row.signaler == 5">强</div>
                  <div v-else>--</div>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                width="160"
                label="记录时间">
                <template slot-scope="scope">
                  <div>{{scope.row.recordTime}}</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!--电气-->
          <div class="look_table_data table_data" v-if="deviceType==1">
            <el-table
              :data="tableData"
              stripe
              @selection-change="handleSelectionChange"
              ref="multipleTable"
              border
              style="max-width: 1360px">
              <el-table-column
                type="selection"
                fixed
                width="54">
              </el-table-column>
              <el-table-column
                label="序号"
                fixed
                width="70">
                <template slot-scope="scope">
                  <div>{{tableParams.pageSize*(tableParams.currentPage-1)+(scope.$index+1)}}</div>
                </template>
              </el-table-column>
              <el-table-column
                label="设备状态"
                min-width="100">
                <template slot-scope="scope">
                  <div v-if="scope.row.deviceStatus" style="color: #f55353">故障</div>
                  <div v-else>启用</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="name"
                label="监测状态"
                min-width="100">
                <template slot-scope="scope">
                  <div v-if="scope.row.runStatus==1" style="color: #f55353">告警</div>
                  <div v-else-if="scope.row.runStatus==2" style="color: #f55353">预警</div>
                  <div v-else>正常</div>
                </template>
              </el-table-column>
              <!-- <el-table-column
                min-width="100"
                show-overflow-tooltip
                label="A相电流(A)">
                <template slot-scope="scope">
                  <div>{{scope.row.ia}}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="ib"
                min-width="100"
                show-overflow-tooltip
                label="B相电流(A)">
              </el-table-column>
              <el-table-column
                prop="ic"
                show-overflow-tooltip
                min-width="100"
                label="C相电流(A)">
              </el-table-column> -->
              <el-table-column
                prop="temp1"
                show-overflow-tooltip
                min-width="100"
                label="温度1(℃)">
              </el-table-column>
              <el-table-column
                prop="temp2"
                show-overflow-tooltip
                min-width="100"
                label="温度2(℃)">
              </el-table-column>
              <el-table-column
                prop="temp3"
                show-overflow-tooltip
                min-width="100"
                label="温度3(℃)">
              </el-table-column>
              <el-table-column
                prop="temp4"
                show-overflow-tooltip
                min-width="100"
                label="温度4(℃)">
              </el-table-column>
              <el-table-column
                prop="rcv"
                show-overflow-tooltip
                min-width="130"
                label="剩余电流(mA)">
              </el-table-column>
              <el-table-column label="信号强度"  width="85">
                  <template slot-scope="scope">
                    <div v-if="scope.row.signaler == 0 || scope.row.signaler == 1 || scope.row.signaler == 2">弱</div>
                    <div v-else-if="scope.row.signaler == 3 || scope.row.signaler == 4 || scope.row.signaler == 5">强</div>
                    <div v-else>--</div>
                  </template>
                </el-table-column>
              <el-table-column
                prop="recordTime"
                show-overflow-tooltip
                min-width="160"
                label="记录时间">
              </el-table-column>
            </el-table>
          </div>
            <div v-if="totalNum >= 50" style="text-align: left;margin-left: 60px;margin-bottom:20px;">
              <el-pagination @size-change="handleSizeChange"  @current-change="handleCurrentChange" :current-page.sync="tableParams.currentPage" :page-sizes="[50, 100, 200, 1000]" :page-size="50" layout="sizes,prev, pager, next,jumper" :total='totalNum' background></el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 快捷选项 -->
  <el-dialog
        :title="title"
        :visible.sync="dialogVisible6"
        width="510px"
        class="report_dialog dialogChaneg"
        :close-on-click-modal="false">
         <div>
              <el-table
                class="user_table"
                ref="checkTable"
                :data="commonquickData"
                tooltip-effect="dark"
                max-height="404px"
                style="width:100%;border:1px solid #e0e0e0;"
                 @selection-change="handleQuickChange">
              <el-table-column
                width="413px"
                prop="text"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column width="55" align="center"  type="selection" :reserver-selection="false">
                <!-- <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.isCheckbox" @change = 'handleQuickChange(scope.row)'></el-checkbox>
                </template> -->
              </el-table-column>
            </el-table>
         </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="editQuick">编辑常用语</el-button>
            <el-button @click="dialogVisible6 = false">取 消</el-button>
            <el-button type="primary" @click="quicImportkExit">确 定</el-button>
        </span>
  </el-dialog>
<!-- 快捷选项 -->

<!-- 常用语 -->
  <el-dialog title="编辑常用语" :visible.sync="outerVisible"         
        width="510px"
        class="report_dialog dialogChaneg"
        :close-on-click-modal="false">
        <div>
        <el-table
          class="user_table"
          ref="multipleTable"
          :data="quickData"
          tooltip-effect="dark"
          max-height="404px"
          style="width:100%;border:1px solid #e0e0e0;">
        <el-table-column
          width="348px"
          prop="text"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column width="120px" align="right">
          <template slot-scope="scope">
              <span class="editTab" @click="handleEdit(scope.$index, scope.row)">编辑</span>
              <span class="deleteTab" @click="handleDelete(scope.$index, scope.row)">删除</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="addquick">新 增</el-button>
      <el-button @click="outerVisible = false">取 消</el-button>
      <el-button type="primary"  @click="outerVisible = false">保存</el-button>
    </div>
  </el-dialog>
  <!-- 常用语 -->

  <!-- 编辑常用语 -->
      <el-dialog
        @open="dialogOpen"
        @close="dialogClose"
        title="编辑常用语"
        :visible.sync="innerVisible"
        width="510px"
        class="report_dialog"
        :close-on-click-modal="false">
        <div><el-input
          type="textarea"
          :rows="4"
          maxlength="25"
          placeholder="最多不超过25个字符"
          v-model="quickTextarea" @change="keyWord">
        </el-input></div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="innerVisible = false">取 消</el-button>
            <el-button type="primary" @click="quickExit">确 定</el-button>
        </span>
  </el-dialog>
  <!-- 编辑常用语 -->
    <!-- 确认提示框 -->
    <el-dialog title="提示" class="tipsTwo" @open="dialogOpen" @close="dialogClose" :visible.sync="dialogTipsSureVisible" :modal-append-to-body="false">
        <div>删除该条常用语后将无法恢复,是否确认删除？</div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogTipsSureVisible = false">取 消</el-button>
            <el-button type="primary" @click="TipsSure">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
  import {ajaxFuncJson} from "../../api/ajax";
  import {upFileIp} from '../../api/ajax'
  import {uploadIp} from '../../api/ajax'
  export default {
    name:'searchForm',
    component:'',
    data(){
      return{
        title:'',
        commonquickData:[],
        quickData:[],
        dialogVisible6:false, //内容
        outerVisible:false, //常用语
        innerVisible:false,
        quickChecked1:[],
        quickChecked2:[],
        quickChecked3:[],
        quickCheckedTxt1:[],
        quickCheckedTxt2:[],
        quickCheckedTxt3:[],
        quickTextarea:'', //编辑的输入框
        editId:'',//区分编辑或新增
        delId:'',//区分删除
        dialogTipsSureVisible:false,
        addType:'',//区分接口
        editType:'',
        totalNum:0, //总条数
        currentPage4:1, //条数
        widthNum: '',   //中间区域自适应宽度
        widthCard: '', //计算卡片宽度
        widthText: '', //计算卡片文本宽度
        total:0,
        formTitle:'编辑报警处理表单',   //面包屑3级名称
        isAddForm:false,    //是否新增表单
        monitorList:[],
        disabled:false,
        progressNum:0,    //进度条
        dialogImageUrl: '',
        maxNumber:5,
        fileList:[],
        dialogVisible: false,
        tableData: [],
        upLoadAjaxUrl:'',
        page:1,
        monitoringName:'',
        monitoringCode:'',
        runStatus:'',
        warningData:false,
        options: [],
        submitTime:'',
        verifyTime:'',
        writeName:'',
        createTime:'', //创建时间
        alarmDealCode:'',   //编辑处理单编号
        deviceType:'',    //设备类型
        basicHeight:'',
        formParams:{     //表单提交字段
          monitoringId:sessionStorage.getItem('saveId'),
          monitoringName:'',
          solveTime:'',      //排故时间
          handleId:[],
          monitorFileInfos:[],
          deleteId:'',
          alarmReason:'',
          alarmRemark:'',
          result:'',
          saveOrSubmit:1,   //1提交 2 保存
          alarmNoticeRecord:[],
        },
        detailAddress:'',  //详细地址
        upImgId:[],
        editTableData:[],    //编辑回显的表格
        selectFirstTime:'',
        errorSelectId:[],
        tableParams:{
          monitorId:'',
          type:'',
          currentPage:1,
          pageSize:50
        },
        editFileId:[],     //获取编辑时候图片的id
        deleteIdAry:[],    //删除id的数组
        pickerOptions:{
          disabledDate(time) {
            return time.getTime()> Date.now();
          },
        },
        isChange:false,
        currentNum1:0,
        currentNum2:0,
        currentNum3:0,
        tipTitle:'确定提交当前报警处理单吗？',
        editFirstSolveTime:'',      //编辑时获取的信息，判断编辑内容是否改变
        editFirstHandleId:'',
        editFirstFileId:'',
        editFirstRemark:'',
        editFirstReason:'',
        editFirstResult:'',
        editFirstTableData:[],
        isEditChange:false,
      }
    },
    created() {
      if(this.$route.query.type==='new_add'){
        this.formTitle='新增报警处理表单';
        this.isAddForm=true;
      }else {
        this.formTitle='编辑报警处理表单';
        this.isAddForm=false;
      }
      this.upLoadAjaxUrl=upFileIp();
      this.tableParams.monitorId=sessionStorage.getItem('saveId');
      this.tableParams.type=this.$route.query.deviceType;
      this.deviceType=this.$route.query.deviceType;
      if(this.isAddForm){
        this.getTableData();
      }
      if(this.isAuth('common:interface')){
        this.getPersonData();
      }
    },
    methods:{
      keyWord(){
        this.quickTextarea = (this.quickTextarea).replace(/[\r\n\s]/g, "");
      },
      dialogOpen(){
        $('.dialogChaneg').addClass('hidedialog');
      },
      dialogClose(){
        $('.dialogChaneg').removeClass('hidedialog');
      },
      convenientBtn(e){//告警故障、告警原因、处理对策/按钮
          this.addType = e;//弹窗类型
          if(e == 1){
            this.title = '请选择报警故障描述内容';
            this.getLisetQuick(1,this.tableParams.type);
          }else if(e ==2){
            this.title = '请选择报警原因分析内容';
            this.getLisetQuick(2,this.tableParams.type);
          }else if(e == 3){
            this.title = '请选择处理结果/对策内容';
            this.getLisetQuick(3,this.tableParams.type);
          }
          this.dialogVisible6 = true;
      },
      handleQuickChange(val){//选项内容变化
          if(this.addType == 1){
             this.quickChecked1 = val;
          }else if(this.addType == 2){
             this.quickChecked2 = val;
          }else if(this.addType == 3){
             this.quickChecked3 = val;
          }
      },
      quicImportkExit(){ //确定添加
      if(this.addType == 1){
          // if(this.quickChecked1 !=''){
            this.quickCheckedTxt1 = [];
            this.quickChecked1.forEach((a,b)=>{
               this.quickCheckedTxt1.push(a.text)
            })
           if(this.quickChecked1 !=''){
             this.formParams.alarmRemark = this.quickCheckedTxt1.join('；') +'。';
           }else{
             this.formParams.alarmRemark ='';
           }
            this.dialogVisible6 = false;
          // }else{
          //   this.$alert('请选择报警故障描述内容！', '提示', {
          //       confirmButtonText: '我知道了',
          //       callback: action => {}
          //     });
          // }
      }else if(this.addType == 2){
          // if(this.quickChecked2 !=''){
            this.quickCheckedTxt2 = [];
            this.quickChecked2.forEach((a,b)=>{
               this.quickCheckedTxt2.push(a.text)
            })
            if(this.quickChecked2 !=''){
               this.formParams.alarmReason = this.quickCheckedTxt2.join('；') +'。';
            }else{
              this.formParams.alarmReason = '';
            }
            this.dialogVisible6 = false;
          // }else{
          //   this.$alert('请选择报警原因分析内容！', '提示', {
          //       confirmButtonText: '我知道了',
          //       callback: action => {}
          //     });
          // }
      }else if(this.addType == 3){
          // if(this.quickChecked3 !=''){
            this.quickCheckedTxt3 = [];
            this.quickChecked3.forEach((a,b)=>{
               this.quickCheckedTxt3.push(a.text)
            })
            if(this.quickChecked3 !=''){
                this.formParams.result = this.quickCheckedTxt3.join('；') +'。';
            }else{
              this.formParams.result ='';
            }
            this.dialogVisible6 = false;
          // }else{
          //   this.$alert('请选择处理结果/对策内容！', '提示', {
          //       confirmButtonText: '我知道了',
          //       callback: action => {}
          //     });
          // }
      }

        // let params = {
        //     alarmDealId:this.params.alarmDealRecordId, //审核处理ID
        //     dealStatus:7, //处理状态;协调7
        //     monitoringId:sessionStorage.getItem('saveId'),//监测点id
        //     content:this.coordinateTextarea //协调资源原因
        //   }
        //   if(params.content ==''){
        //       this.$alert('请输入资源协调说明！', '提示', {
        //           confirmButtonText: '我知道了',
        //           callback: action => {}
        //         });
        //   }else{
        //     ajaxFuncJson('/alarmManager/leaderHandleReport',params).then(res=>{
        //       if(res.data.status==200){
        //         this.$router.push({path:'/content/warnExamine'}); //报警处理
        //       }else {
        //         this.$message({
        //           message:res.data.msg,
        //           type:'error',
        //         })
        //       }
        //     });
        //   }
      },
      editQuick(){//编辑常用语、按钮
        this.outerVisible = true;
        this.getLisetQuickAjax(this.addType,this.tableParams.type);
      },
      handleEdit(a,b){//编辑常用语
         this.innerVisible = true;
         this.quickTextarea = b.text;
         this.editId = b.id;
         this.editType = 0;
      },
      handleDelete(c,d){ //删除常用语
         this.dialogTipsSureVisible = true;
         this.delId = d.id;
      },
      TipsSure(){ //删除常用语确定
            let params = {
              id:this.delId
            }
          ajaxFuncJson('/dictionary/delDictionary',params).then(res=>{
            if(res.data.status==200){
             this.getLisetQuickAjax(this.addType,this.tableParams.type);
                if(this.addType == 1){
                  this.getLisetQuick(1,this.tableParams.type);
                }else if(this.addType ==2){
                  this.getLisetQuick(2,this.tableParams.type);
                }else if(this.addType == 3){
                  this.getLisetQuick(3,this.tableParams.type);
                }
            }else {
              this.$message({
                message:res.data.msg,
                type:'error',
              })
            }
          });

      },
      addquick(){ //新增常用语
       this.quickTextarea = '';
       this.innerVisible = true;
       this.editType = 1;
      },
      quickExit(){ //输入成功按钮
          if(this.editType == 1){
            var params = {
              type:this.addType,
              text:this.quickTextarea,
              value:this.tableParams.type
            }
          if(this.quickTextarea == ''){

          }else{
            if(this.quickData.length<10){
                ajaxFuncJson('/dictionary/addAndUpdateDictionary',params).then(res=>{
                  if(res.data.status==200){
                  this.getLisetQuickAjax(this.addType,this.tableParams.type);
                      if(this.addType == 1){
                        this.getLisetQuick(1,this.tableParams.type);
                      }else if(this.addType ==2){
                        this.getLisetQuick(2,this.tableParams.type);
                      }else if(this.addType == 3){
                        this.getLisetQuick(3,this.tableParams.type);
                      }
                  }else {
                    this.$message({
                      message:res.data.msg,
                      type:'error',
                    })
                  }
                });
            }
          }
          }else{
            var params = {
              id:this.editId,
              type:this.addType,
              text:this.quickTextarea,
              value:this.tableParams.type
            }
          if(this.quickTextarea == ''){

          }else{
                ajaxFuncJson('/dictionary/addAndUpdateDictionary',params).then(res=>{
                  if(res.data.status==200){
                  this.getLisetQuickAjax(this.addType,this.tableParams.type);
                      if(this.addType == 1){
                        this.getLisetQuick(1,this.tableParams.type);
                      }else if(this.addType ==2){
                        this.getLisetQuick(2,this.tableParams.type);
                      }else if(this.addType == 3){
                        this.getLisetQuick(3,this.tableParams.type);
                      }
                  }else {
                    this.$message({
                      message:res.data.msg,
                      type:'error',
                    })
                  }
                });
              }
          }
      },
      getLisetQuick(type,value){
        let params = {
             type:type,
             value:value
          }
          ajaxFuncJson('/dictionary/getDictionaryType',params).then(res=>{
            if(res.data.status==200){
              this.commonquickData = res.data.data;
                  if(this.addType == 1){
                      if (this.quickCheckedTxt1.length>0){
                          this.commonquickData.forEach((a,b) => {
                            this.quickCheckedTxt1.forEach((c,d)=>{
                              if(a.text==c){
                                  a.isCheckbox = true;
                              }
                            })
                          });
                            this.$nextTick(()=>{
                              this.commonquickData.forEach(row => {
                                    if(row.isCheckbox == true){
                                      this.$refs.checkTable.toggleRowSelection(row);
                                    }
                                });
                            })
                      }else{
                        this.$refs.checkTable.clearSelection();
                      }
                  }
                   if(this.addType == 2){
                      if (this.quickCheckedTxt2.length>0){
                          this.commonquickData.forEach((a,b) => {
                            this.quickCheckedTxt2.forEach((c,d)=>{
                              if(a.text==c){
                                  a.isCheckbox = true;
                              }
                            })
                          });
                            this.$nextTick(()=>{
                              this.commonquickData.forEach(row => {
                                    if(row.isCheckbox == true){
                                      this.$refs.checkTable.toggleRowSelection(row);
                                    }
                                });
                            })
                      }else{
                        this.$refs.checkTable.clearSelection();
                      }
                  }
                   if(this.addType == 3){
                      if (this.quickCheckedTxt3.length>0){
                          this.commonquickData.forEach((a,b) => {
                            this.quickCheckedTxt3.forEach((c,d)=>{
                              if(a.text==c){
                                  a.isCheckbox = true;
                              }
                            })
                          });
                            this.$nextTick(()=>{
                              this.commonquickData.forEach(row => {
                                    if(row.isCheckbox == true){
                                      this.$refs.checkTable.toggleRowSelection(row);
                                    }
                                });
                            })
                      }else{
                        this.$refs.checkTable.clearSelection();
                      }
                  }

            }else {
              this.$message({
                message:res.data.msg,
                type:'error',
              })
            }
          });
      },
    getLisetQuickAjax(type,value){
        let params = {
             type:type,
             value:value
          }
          ajaxFuncJson('/dictionary/getDictionaryType',params).then(res=>{
            if(res.data.status==200){
              this.quickData = res.data.data;
              this.innerVisible = false; //关闭编辑常用语输入框
              this.dialogTipsSureVisible = false;//删除弹框
            }else {
              this.$message({
                message:res.data.msg,
                type:'error',
              })
            }
          });
      },
      handleSizeChange(val){//切换条数
          this.tableData = [];
          this.tableParams.pageSize = val;
          if(this.$route.query.type==='new_add'){
            this.getTableData();
          }else{
            this.getEditTableInfo();
          }
      },
      handleCurrentChange(val){ //切换
          this.tableData = [];
          this.tableParams.currentPage = val;
          if(this.$route.query.type==='new_add'){
            this.getTableData();
          }else{
            this.getEditTableInfo();
          }

      },
      linkIndex(){
        if(this.isAddForm){
          this.isChangeContent();
          if(this.isChange){
            this.$confirm('本次新增内容尚未保存，确定退出吗？','提示',{
              confirmButtonText:'确定',
              cancelButtonText:'取消',
              closeOnClickModal:false,
              closeOnPressEscape:false,
            }).then(()=>{
              this.$router.push({path:'/content/warningManger'})
            }).catch(()=>{

            })
          }else {
            this.$router.push({path:'/content/warningManger'})
          }
        }else {
          this.isEditChangeContent();
          if(this.isEditChange){
            this.$confirm('本次编辑内容尚未保存，确定退出吗？','提示',{
              confirmButtonText:'确定',
              cancelButtonText:'取消',
              closeOnClickModal:false,
              closeOnPressEscape:false,
            }).then(()=>{
              this.$router.push({path:'/content/warningManger'})
            }).catch(()=>{

            })
          }else {
            this.$router.push({path:'/content/warningManger'})
          }
        }
      },
      //面板屑导航
      linkDetail(){
        if(this.isAddForm){
          this.isChangeContent();
          if(this.isChange){
            this.$confirm('本次新增内容尚未保存，确定退出吗？','提示',{
              confirmButtonText:'确定',
              cancelButtonText:'取消',
              closeOnClickModal:false,
              closeOnPressEscape:false,
            }).then(()=>{
              this.$router.push({path:'/content/warnDetail'})
            }).catch(()=>{

            })
          }else {
            this.$router.push({path:'/content/warnDetail'})
          }
        }else {
          this.isEditChangeContent();
          if(this.isEditChange){
            this.$confirm('本次编辑内容尚未保存，确定退出吗？','提示',{
              confirmButtonText:'确定',
              cancelButtonText:'取消',
              closeOnClickModal:false,
              closeOnPressEscape:false,
            }).then(()=>{
              this.$router.push({path:'/content/warnDetail'})
            }).catch(()=>{

            })
          }else {
            this.$router.push({path:'/content/warnDetail'})
          }
        }
      },
      returnBtn(){ //返回按钮;
        if(this.isAddForm){
          this.isChangeContent();
          if(this.isChange){
            this.$confirm('本次新增内容尚未保存，确定退出吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              closeOnClickModal:false,
              closeOnPressEscape:false,
            }).then(() => {
              this.$router.push({path:'/content/warnDetail'}); //报警处理
            }).catch(() => {

            });
          }else {
            this.$router.push({path:'/content/warnDetail'}); //报警处理
          }
        }else {
          this.isEditChangeContent();
          if(this.isEditChange){
            this.$confirm('本次编辑内容尚未保存，确定退出吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              closeOnClickModal:false,
              closeOnPressEscape:false,
            }).then(() => {
              this.$router.push({path:'/content/searchForm',query:{id:this.$route.query.id,deviceType:this.$route.query.deviceType,searchUrl:'1-1'}}); //报警处理
            }).catch(() => {

            });
          }else {
            this.$router.push({path:'/content/searchForm',query:{id:this.$route.query.id,deviceType:this.$route.query.deviceType,searchUrl:'1-1'}}); //报警处理
          }
        }
      },

      //实时获取文本的字数
      getSizeNum3(val){
        this.currentNum3=val.length;
      },
      //实时获取文本的字数
      getSizeNum2(val){
        this.currentNum2=val.length;
      },
      //实时获取文本的字数
      getSizeNum1(val){
        this.currentNum1=val.length;
      },
      //效验是否已填写内容
      isChangeContent(){
          if(this.formParams.handleId.length!=0||this.formParams.alarmRemark!=''||this.formParams.alarmReason!=''||this.formParams.result!=''||this.formParams.alarmNoticeRecord.length!=0||this.formParams.monitorFileInfos.length!=0||this.formParams.solveTime!=''){
              this.isChange=true;
          }else {
              this.isChange=false;
          }
      },
      //效验编辑是否已修改内容
      isEditChangeContent(){
        if(this.formParams.handleId.join(',')!=this.editFirstHandleId||this.formParams.alarmRemark!=this.editFirstRemark||this.formParams.alarmReason!=this.editFirstReason||this.formParams.result!=this.editFirstResult||this.formParams.solveTime!=this.editFirstSolveTime||this.editFirstFileId.length!=this.formParams.monitorFileInfos.length){
          this.isEditChange=true;
        }else {
          this.validateTable();
        }
      },
      //效验表格是否已经修改
      validateTable(){
        if(this.editFirstTableData.length!==this.formParams.alarmNoticeRecord.length){
          this.isEditChange=true
        }else {
          var ary=[];
          this.editFirstTableData.forEach((a,b)=>{
            if(this.formParams.alarmNoticeRecord.indexOf(a)===-1){
              ary.push(b);
            }
          });
          if(ary.length!==this.editFirstTableData.length){
            this.isEditChange=true;
          }else {
            this.isEditChange=false;
          }
        }
      },
      //获取编辑的信息
      getEditInfo(){
        let params={
          alarmDealRecordId:this.$route.query.id,
          monitorId:sessionStorage.getItem('saveId'),
        };
        ajaxFuncJson('/alarmManager/getAlarmSheet',params).then(res=>{
          if(res.data.status==200){
            this.getEditTableInfo();
            this.formParams.solveTime=res.data.data.solveTime;
            this.editFirstSolveTime=res.data.data.solveTime;
            if(res.data.data.handleId){
              this.formParams.handleId=res.data.data.handleId.split(',');
            }else {
              this.formParams.handleId=[];
            }
            if(this.options){
              this.options.map((item,index)=>{
                  if(res.data.data.managePeople){
                      res.data.data.managePeople.map((items,indexes)=>{
                        items.disabled=true;
                        if(item.id==items.id){
                          res.data.data.managePeople.splice(indexes,1);
                        }
                      });
                  }
              });
            }
            if(res.data.data.managePeople){
              this.options=this.options.concat(res.data.data.managePeople);
            }else{
              this.options=this.options
            }
            this.editFirstHandleId=res.data.data.handleId;
            this.formParams.alarmReason=res.data.data.alarmReason;
            this.editFirstReason=res.data.data.alarmReason;
            this.currentNum2=res.data.data.alarmReason.length;
            this.formParams.alarmRemark=res.data.data.alarmRemark;
            this.editFirstRemark=res.data.data.alarmRemark;
            this.currentNum1=res.data.data.alarmRemark.length;
            this.formParams.result=res.data.data.result;
            this.editFirstResult=res.data.data.result;
            this.currentNum3=res.data.data.result.length;
            this.alarmDealCode=res.data.data.alarmDealCode;
            this.createTime=res.data.data.createTime;
            this.submitTime=res.data.data.submitTime;
            this.verifyTime=res.data.data.verifyTime;
            this.writeName=res.data.data.writeName;
            this.editFileId=res.data.data.photoId.split(',');
            this.editFirstFileId=res.data.data.photoId.split(',');
            if(res.data.data.photoId){
              this.editFileId.forEach((a,b)=>{
                let json={},json1={};
                json.id=a;
                json.name=(b+1)+'img';
                json.url=uploadIp()+'/file/filePreview/'+a;
                json1.id=a;
                json1.fileName='';
                json1.fileExtend='';
                json1.fileSize='';
                json1.filePath='';
                this.fileList.push(json);
                this.formParams.monitorFileInfos.push(json1);
              });
            }
            
            if(this.editFileId.length==5){
              let uploadBtn=document.getElementsByClassName('el-upload--picture-card')[0];
              uploadBtn.style.display='none';
            }
            let _this=this;
            this.$nextTick(()=>{
              $('.upload_img').find('img').each(function (index,item) {
                _this.ImgAutoContainer($(this),80,80);
              })
            });
          }
        })
      },
      //编辑请求提交
      editFormAjax(){
        this.formParams.change=1;
        this.formParams.type=this.deviceType;
        this.formParams.monitoringName=this.monitoringName;
        this.formParams.handleId=this.formParams.handleId.join(',');
        this.formParams.id=this.$route.query.id;
        this.formParams.deleteId=this.deleteIdAry.join(',');
        // this.formParams.monitoringType =res.data.data.type;
        ajaxFuncJson('/alarmManager/changeDealMonitorRecord',this.formParams).then(res=>{
            if(res.data.status==200){
              if(this.formParams.saveOrSubmit===1){
                this.$router.push({path:'/content/submitSuccess',query:{url:'1-2',id:this.$route.query.id,deviceType:this.deviceType}}); //报警处理
              }else {
                this.$router.push({path:'/content/saveSuccess',query:{url:'1-1'}}); //报警处理
              }
            }else if(res.data.status==300){
              this.getEditTableInfo(1);
              this.formParams.handleId=this.formParams.handleId.split(',');
              this.$message({
                message:res.data.msg,
                type:'error',
              })
            }else {
              this.$message({
                message:res.data.msg,
                type:'error',
              })
            }
        });
      },
      //获取编辑表格的数据
      getEditTableInfo(type){
        let params={
          alarmDealRecordId:this.$route.query.id,
          monitorId:sessionStorage.getItem('saveId'),
          type:this.$route.query.deviceType,
          currentPage:this.tableParams.currentPage,
          pageSize:this.tableParams.pageSize
        };
        ajaxFuncJson('/alarmManager/getEditDealMonitorRecord',params).then(res=>{
          if(res.data.status==200){
            this.errorSelectId=[];
            this.tableData=res.data.data;
            if(this.tableData[0].count){
                this.totalNum = this.tableData[0].count;
              }
            if(this.deviceType==2){    //水压
              this.tableData.forEach((a,b)=>{
                this.tableData[b].rcv=this.accDiv(a.rcv,1000);
              })
            }else if(this.deviceType==3){   //液位
              this.tableData.forEach((a,b)=>{
                this.tableData[b].rcv=this.accDiv(a.rcv,100);
              })
            }
            this.tableData.forEach((a,b)=>{
              this.selectFirstTime=this.tableData[0].recordTime;
              this.$set(a, 'index', b+1);
              if(!type){
                if(a.alarmDealRecordId){
                  this.$nextTick(()=>{
                    this.$refs.multipleTable.toggleRowSelection(a,true);
                  });
                  let json={};
                  json.id=a.alarmNoticeRecordId;
                  json.monitoringCode=this.monitoringCode;
                  json.monitoringRecordId=a.id;
                  json.monitoringType=this.deviceType;
                  json.detailAddress=this.detailAddress;
                  
                  this.formParams.alarmNoticeRecord.push(json);
                  this.editFirstTableData.push(json);
                  if(a.recordTime<this.selectFirstTime){
                    this.selectFirstTime=a.recordTime;
                  }
                }
              }
            });
            if(type){
              if(this.formParams.alarmNoticeRecord.length!=0){
                this.tableData.forEach((item,index)=>{
                  this.formParams.alarmNoticeRecord.forEach((list,listIndex)=>{
                    if(item.id==list.monitoringRecordId){
                      this.$nextTick(()=>{
                        this.$refs.multipleTable.toggleRowSelection(item);
                      });
                      this.errorSelectId.push(list);
                    }
                  })
                })
              }
              this.formParams.alarmNoticeRecord=this.errorSelectId;
            }
          }
        })
      },
      //保存表单数据
      saveFormData(){
        // this.isRequestFill(1);
          this.tipTitle='确定保存当前报警处理单吗';
          this.formParams.saveOrSubmit=2;
          
          this.$confirm(this.tipTitle, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              closeOnClickModal:false,
              closeOnPressEscape:false,
            }).then(() => {
              if(this.isAddForm){
                this.submitAjax();
              }else {
                this.editFormAjax();
              }
            }).catch(() => {});
      },
      //选中的表格数据
      handleSelectionChange(val){
          this.formParams.alarmNoticeRecord=[];
          if(val.length>0){
            this.selectFirstTime=val[0].recordTime;
          }
          val.forEach((item,index)=>{
            let json={};
            json.id=item.alarmNoticeRecordId;
            json.monitoringCode=this.monitoringCode;
            json.monitoringRecordId=item.id;
            json.monitoringType=this.deviceType;
            json.detailAddress=this.detailAddress;
            json.createDate=item.recordTime;
            this.formParams.alarmNoticeRecord.push(json);
            if(item.recordTime<this.selectFirstTime){
              this.selectFirstTime=item.recordTime;
            }
          });
      },
      //效验是否填写完整
      isRequestFill(type)  {
        if(type===1){
          this.tipTitle='确定保存当前报警处理单吗';
          this.formParams.saveOrSubmit=2;
        }else {
          this.tipTitle='确定提交当前报警处理单吗';
          this.formParams.saveOrSubmit=1;
        }
          if(this.formParams.handleId.length==0 && type!==1){
            this.$alert('信息填写不完善，请完善信息', '提示', {
              confirmButtonText: '我知道了',
              callback: action => {}
            });
          }else {//四期处理去除校验
             if(this.formParams.alarmRemark==''){
               this.$alert('信息填写不完善，请完善信息', '提示', {
                 confirmButtonText: '我知道了',
                 callback: action => {

                 }
               });
             }else {
               if(this.formParams.alarmReason==''){
                 this.$alert('信息填写不完善，请完善信息', '提示', {
                   confirmButtonText: '我知道了',
                   callback: action => {

                   }
                 });
               }else {
                 if(this.formParams.result==''){
                   this.$alert('信息填写不完善，请完善信息', '提示', {
                     confirmButtonText: '我知道了',
                     callback: action => {

                     }
                   });
                 }else {
                   if(this.formParams.alarmNoticeRecord.length==0){
                     this.$alert('信息填写不完善，请完善信息', '提示', {
                       confirmButtonText: '我知道了',
                       callback: action => {

                       }
                     });
                 }else {
                     if(this.formParams.monitorFileInfos.length==0){
                       this.$alert('信息填写不完善，请完善信息', '提示', {
                         confirmButtonText: '我知道了',
                         callback: action => {

                         }
                       });
                     }else {
                       if(this.formParams.solveTime<this.selectFirstTime||new Date(this.formParams.solveTime).getTime()>Date.now()){
                         this.$alert('排故时间需在未处理告警的最早时间到当前时间之间', '提示', {
                           confirmButtonText: '我知道了',
                           callback: action => {

                           }
                         });
                       }else {
                         this.$confirm(this.tipTitle, '提示', {
                           confirmButtonText: '确定',
                           cancelButtonText: '取消',
                           closeOnClickModal:false,
                           closeOnPressEscape:false,
                         }).then(() => {
                           if(this.isAddForm){
                             this.submitAjax();
                           }else {
                             this.editFormAjax();
                           }
                         }).catch(() => {});
                       }
                     }
                   }
                 }
               }
             }
          }
      },
      //提交审核 效验未告警数据是否已被提交
      submitAjax(){
        this.formParams.monitoringName=this.monitoringName;
        this.formParams.handleId=this.formParams.handleId.join(',');
        ajaxFuncJson('/alarmManager/creatAlarmSheet',this.formParams).then(res=>{
          if(res.data.status==200){
            if(this.formParams.saveOrSubmit===1){
              this.$router.push({path:'/content/submitSuccess',query:{url:'1-1',id:res.data.data,deviceType:this.deviceType}}); //报警处理
            }else {
              this.$router.push({path:'/content/saveSuccess',query:{url:'1-1'}}); //报警处理
            }
          }else if(res.data.status==300){
            if(this.isAddForm){
              this.getTableData();
              this.formParams.handleId=this.formParams.handleId.split(',');
            }else {
              this.getEditTableInfo();
              this.formParams.handleId=this.formParams.handleId.split(',');
            }
          this.$alert(res.data.msg, '提示', {
              confirmButtonText: '我知道了',
              callback: action => {

              }
            });
          }else {
            this.$message({
              message:res.data.msg,
              type:'error'
            })
          }
        })
      },
      //获取新增个人的信息
      getPersonData(){
        let params={
          monitorId: this.tableParams.monitorId
        };
        ajaxFuncJson('/alarmManager/getMonitorMessage',params).then(res=>{
          if(res.data.status==200){
            if(!this.isAddForm){        //调用编辑接口
                this.getEditInfo();
              }
              this.options=res.data.data.managePeople;
              this.monitoringCode=res.data.data.monitoringCode;
              this.monitoringName=res.data.data.monitoringName;
              this.detailAddress=res.data.data.detailAddress;
              this.formParams.monitoringType =res.data.data.type;
              if(res.data.data.runStatus==1){
                this.runStatus='告警';
              }else if(res.data.data.runStatus==2){
                this.runStatus='预警';
              }else{
                this.runStatus='正常';

              }
          }
        })
      },
      //相除时防止浮点数值转化
      accDiv(arg1,arg2){
        var t1=0,t2=0,r1,r2;
        try{
          t1=arg1.toString().split(".")[1].length;
        }catch(e){}

        try{
          t2=arg2.toString().split(".")[1].length;
        }catch(e){}
        r1=Number(arg1.toString().replace(".",""));
        r2=Number(arg2.toString().replace(".",""));
        return (r1/r2)*Math.pow(10,t2-t1);
      },
      //获取未处理告警的数据
      getTableData(){
        ajaxFuncJson('/alarmManager/getNoDealAlarmMessage',this.tableParams).then(res=>{
            if(res.data.status==200){
                this.errorSelectId=[];
                this.tableData=res.data.data;
                if(this.tableData[0]){
                  this.totalNum = this.tableData[0].count;
                }
                this.tableData.forEach((item,index)=>{
                  this.$set(item, 'index', index+1)
                });
              if(this.deviceType==2){    //水压
                this.tableData.forEach((a,b)=>{
                  this.tableData[b].rcv=this.accDiv(a.rcv,1000);
                })
              }else if(this.deviceType==3){   //液位
                this.tableData.forEach((a,b)=>{
                  this.tableData[b].rcv=this.accDiv(a.rcv,100);
                })
              }
                if(this.formParams.alarmNoticeRecord.length!=0){
                  this.tableData.forEach((item,index)=>{
                    this.formParams.alarmNoticeRecord.forEach((list,listIndex)=>{
                      if(item.id==list.monitoringRecordId){
                        this.$nextTick(()=>{
                          this.$refs.multipleTable.toggleRowSelection(item);
                        });
                        this.errorSelectId.push(list);
                      }
                    })
                  })
                }
              this.formParams.alarmNoticeRecord=this.errorSelectId;
            }
        })
      },
      //文件上传时
      handleProgress(event,file,fileList){
        // this.progressNum=Math.floor((event.loaded / event.total)*100);//计算百分比
      },
      //上传之前
      beforeAvatarUpload(file){
        const isLt2M = file.size / 1024 / 1024 < 10;
        const isJPG = file.type === 'image/jpg';
        const isJPEG = file.type === 'image/jpeg';
        const isPNG = file.type === 'image/png';
          if(!isJPG && !isJPEG && !isPNG){
            return false;
          }
        if(!isLt2M) {
          this.$message({
            message: '上传的照片不能超过10MB，请重新上传！',
            type: 'warning'
          });
          return false;
        }
      },
      //上传成功
      upLoadImg(response,file,files){
        if(response.status==200){
          this.fileList=files;
          let json={
            fileName:response.data.originalFilename,
            fileExtend:response.data.fileExtend,
            fileSize:response.data.size,
            filePath: response.data.savePath,
            id:'',
          };
          this.formParams.monitorFileInfos.push(json);
          if(this.fileList.length===5){
            let uploadBtn=document.getElementsByClassName('el-upload--picture-card')[0];
            uploadBtn.style.display='none';
          }
          let _this=this;
          this.$nextTick(()=>{
            $('.upload_img').find('img').each(function (index,item) {
              _this.ImgAutoContainer($(this),80,80);
            })
          });
        }
      },
      ImgAutoContainer(Img,maxWidth,maxHeight){
        var image = new Image();
        //原图片原始地址（用于获取原图片的真实宽高，当<img>标签指定了宽、高时不受影响）
        image.src = Img.attr('src');
        image.onload=function () {
          if (maxWidth/ maxHeight  < image.width / image.height) //原图片宽高比例 大于 图片框宽高比例  100  50   100  20
          {

            Img.css({'width':'auto','height':'100%','left':-(image.width / image.height*80-80)/2+'px','position':'relative'});  //以框的宽度为标准

          }
          else {   //原图片宽高比例 小于 图片框宽高比例
            Img.css({'width':'100%','height':'auto','top':(image.width / image.height*80-80)/2+'px','position':'relative'});  //以框的高度为标准
          }
        };
      },
      handleRemove(file, fileList) {
        this.fileList.forEach((item,index)=>{
          if(item.uid==file.uid){
            if(this.formParams.monitorFileInfos[index].filePath==''){
              this.deleteIdAry.push(this.formParams.monitorFileInfos[index].id);
            }
            this.formParams.monitorFileInfos.splice(index,1);
          }
        });
        if(fileList.length<5){
          let uploadBtn=document.getElementsByClassName('el-upload--picture-card')[0];
          uploadBtn.style.display='inline-block';
        }
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      //切换表格
      changeData(){
          this.warningData=!this.warningData;
      }
    },
    mounted(){
      this.$nextTick(()=>{
        this.basicHeight=$(window).height()-$('.mainHead').outerHeight(true)-81;
      })
    },
  }
</script>

<style scoped>
  .shadow{
    position: fixed;
    height: 10px;
    left: 0;
    top: 61px;
    width: 100%;
    background: #f2f2f2;
    z-index: 1;
  }
  .main{
   background: #fff;
    overflow: auto;
  }

  .main .maindetails{
    padding: 30px 0 0 70px;
  }
  .router_link:hover{
    color:#198CFF;
    cursor: pointer;
  }
.item_info{
  display: flex;
  margin-bottom: 35px;
  font-size: 14px;
  color: #282828;
}
.upload_process{
  position: absolute;
  left: 13px;
  top: 13px;
}
.img_preview{
  width: 100%;
  height: 100%;
  position: fixed;
  background: #000;
  opacity: .6;
  left: 0;
  top:0;
  z-index: 99;
}
.textarea_tip{
  position: absolute;
  right: 15px;
  bottom: 3px;
  color: #8a8a8a;
  font-size: 12px;
  z-index: 1;
  padding: 0 2px;
  background: #fff;
}
.item_info p:nth-of-type(1){
  width: 490px;
}
.item_info p span{
  display: inline-block;
  width: 95px;
}
  .warning_desi{
    padding: 13px 20px 10px 70px;
    color: #282828;
    font-weight: 700;
    font-size: 14px;
  }
  .warning_desi .crumbs{
    display: inline-block;
    width: 6px;
    height: 16px;
    background: #198cff;
    vertical-align: -3px;
    margin-right: 8px;
  }
  .warning_desi_data{
    padding-left: 70px;
    margin-bottom: 25px;
    width: 953px;
    position: relative;
  }
  .list_result{
    padding:15px 10px;
    font-size: 13px;
    color: #282828;
    width: 883px;
    border: 1px solid #ffe0cb;
    border-radius: 2px;
    background: #FFF7E7;
    margin-bottom: 10px;
  }
  .list_result p{
    float: left;
    padding-bottom: 10px;
  }
  .list_result .first_time{
    float: right;
  }
 .result_type{
   background: #E8F8E9;
   border: 1px solid #8ae58d;
 }
  .look_table_data{
    padding-left: 70px;
    padding-bottom: 40px;
    margin-top: 15px;
  }
  .img_container img{
    width: 100%;
    height: auto;
  }
  .all_img_container{
    display: flex;
    flex-wrap: nowrap;
    padding-left: 95px;
    width: 800px!important;
  }

  .editTab{
    display: inline-block;
    margin-right: 15px;
    color: #198cff;
    cursor: pointer;
  }
  .deleteTab{
    display: inline-block;
    margin-right: 10px;
    color:#f56c6c;
    cursor: pointer;
  }
  .convenientBtn{
    display: inline-block;
    margin-left: 8px;
    vertical-align: middle;
    cursor: pointer;
  }
  .hidedialog{
    z-index:0!important;
  }
</style>




// WEBPACK FOOTER //
// src/page/warningManger/editForm.vue